import { ThemeDefinition } from 'vuetify/framework';
import { addStatusColors } from './vuetify-theme-shared';

export const naiveDark: ThemeDefinition = addStatusColors({
    dark: true,
    colors: {
        // role colors = Naive DARK "Default"
        primary: '#63e2b7',
        secondary: '#8a8a8a',
        info: '#70c0e8',
        success: '#63e2b7',
        warning: '#f2c97d',
        error: '#e88080',

        background: '#121212',
        surface: '#1E1E1E',
        'on-background': '#E6E6E6',
        'on-surface': '#E6E6E6',
    },
    variables: {
        // --- primary
        'naive-primary-hover': '#7fe7c4',
        'naive-primary-default': '#63e2b7',
        'naive-primary-active': '#5acea7',
        'naive-primary-suppl': 'rgb(42, 148, 125)',
        // --- info
        'naive-info-hover': '#8acbec',
        'naive-info-default': '#70c0e8',
        'naive-info-active': '#66afd3',
        'naive-info-suppl': 'rgb(56, 137, 197)',
        // --- error
        'naive-error-hover': '#e98b8b',
        'naive-error-default': '#e88080',
        'naive-error-active': '#e57272',
        'naive-error-suppl': 'rgb(208, 58, 82)',
        // --- warning
        'naive-warning-hover': '#f5d599',
        'naive-warning-default': '#f2c97d',
        'naive-warning-active': '#e6c260',
        'naive-warning-suppl': 'rgb(240, 138, 0)',
        // --- success
        'naive-success-hover': '#7fe7c4',
        'naive-success-default': '#63e2b7',
        'naive-success-active': '#5acea7',
        'naive-success-suppl': 'rgb(42, 148, 125)',
    },
});
